module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/user_way_bg-fed3cf21f6cf6b9689f66680b950c586.jpg";